<template>
    <Card :header="$t('companySettings')" content-class="d-flex flex-wrap gap-column-3 child-flex-basis-100">

        <FormValidator :validator="$v.form.companyName" form-group v-slot="slotProps" :label="$t('companyName')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.companyName" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.companyNip" form-group v-slot="slotProps" :label="$t('companyNip')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.companyNip" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.street" form-group v-slot="slotProps" :label="$t('street')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.street" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.streetNumber" form-group v-slot="slotProps" :label="$t('streetNumber')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.streetNumber" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.apartmentNumber" form-group v-slot="slotProps" :label="$t('apartmentNumber')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.apartmentNumber" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.city" form-group v-slot="slotProps" :label="$t('city')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.city" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.postcode" form-group v-slot="slotProps" :label="$t('postcode')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-input v-model="form.postcode" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <FormValidator :validator="$v.form.country" form-group v-slot="slotProps" :label="$t('country')" class="flex-basis-40 flex-grow-1 flex-shrink-0 width-min-200">
            <b-form-select v-model="form.country" :options="optionsCountry" :disabled="busy" :state="slotProps.state" />
        </FormValidator>

        <div class="d-flex gap-3 mt-5">
            <ButtonIcon :loading="saving" :disabled="busy" class="wide" @click="formSubmit()">
                {{ $t('save') }}
            </ButtonIcon>
        </div>

    </Card>
</template>



<script>
    import FormValidator from '@/components/common/FormValidator.vue';
    import { required } from 'vuelidate/lib/validators';
    import formBackendValidationMixin from '@/mixins/formBackendValidationMixin';
    import { deepMergeWithFilter, scrollToElement } from '@/utils/util';
    import cloneDeep from 'lodash/cloneDeep';
    import countryService from '@/services/countryService';

    const FORM_DEFAULT_DATA = Object.freeze({
        companyName: '',
        companyNip: '',
        street: '',
        streetNumber: null,
        apartmentNumber: null,
        city: '',
        postcode: '',
        country: '',
    });

    export default {
        name: 'CompanySettings',
        mixins: [formBackendValidationMixin],
        components: {
            FormValidator,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestUserProfile,
                form: cloneDeep(FORM_DEFAULT_DATA),
                formValidations: {
                    form: {
                        companyName: { required },
                        companyNip: { required },
                        street: {},
                        streetNumber: {},
                        apartmentNumber: {},
                        city: {},
                        postcode: { required },
                        country: {},
                    },
                },
            };
        },
        computed: {
            user() {
                return this.parentComponent.user;
            },
            loading() {
                return this.parentComponent.requestUser.getLoading();
            },
            saving() {
                return this.request.getLoading('patch');
            },
            busy() {
                return this.loading || this.saving;
            },
            optionsCountry() {
                return countryService.getCountryOptions();
            },
        },
        watch: {
            user(data, oldData) {
                if (data && data !== oldData) this.initFormData(data);
            },
        },
        methods: {
            initFormData() {
                const data = { ...(this.user?.profile || {}) };
                const form = deepMergeWithFilter(FORM_DEFAULT_DATA, data);
                this.form = form;
            },
            async formSubmit() {
                this.$v.form.$touch();
                if (this.$v.form.$invalid) {
                    await this.$nextTick();
                    scrollToElement('.is-invalid', { offset: -80 });
                    return;
                }
                this.request
                    .id('patch')
                    .patch({ urlParams: { id: this.user.id }, requestParams: this.form })
                    .then(() => {
                        this.parentComponent.updateUser();
                        this.$toastr.success(this.$t('dataSavedSuccessfully'));
                        this.$v.form.$reset();
                    })
                    .catch(this.handleBackendValidations);
            },
        },
    };
</script>
